import { useSelector } from 'react-redux';

import {
	selectActiveCompany,
	selectActiveScope,
	selectUserFirstName,
	selectUserLastName,
} from '@shared/api/reduxToolkit';
import { getAvatarInitials, getCompanyInitials } from '@shared/lib/utils';

import { Avatar } from './Avatar';

export const AvatarIdentity = ({ size = 'sm', mode = 'auto' }) => {
	const activeScope = useSelector(selectActiveScope);
	const activeCompany = useSelector(selectActiveCompany);
	const firstName = useSelector(selectUserFirstName);
	const lastName = useSelector(selectUserLastName);

	const effectiveMode = mode === 'auto' ? activeScope : mode;
	const shouldShowCompanyAvatar = effectiveMode === 'company' && Boolean(activeCompany?.name);

	const initials = shouldShowCompanyAvatar
		? getCompanyInitials({
				companyName: activeCompany.name,
			})
		: getAvatarInitials({
				firstName,
				lastName,
			});

	const variant = shouldShowCompanyAvatar ? 'company' : 'user';

	return <Avatar initials={initials} size={size} variant={variant} />;
};
